// What the admin is told when switching a module on can't load its data.
//
// /refreshModule answers 400 for a setup problem (HockeyTech not configured,
// no team id, an unknown module), which won't fix itself, and 500 when
// HockeyTech couldn't be read, which the poller retries every few minutes.
// The module is switched on either way.
export function moduleRefreshWarning(status, error) {
    if (status >= 500) {
        return "Couldn't reach the stats feed. The module is on and will fill in on its own once the feed is back.";
    }
    return `The module is on, but its data couldn't be loaded: ${error || 'unknown error'}`;
}
